import { handleActions } from 'redux-actions';

import log from 'utils/logger' // eslint-disable-line

const initialValue = {
  devices: [],
  devices_by_id: {},
  loading: true,
  showCreator: false,
  view: 'show'
}

export default handleActions({
  SHOW_DEVICE_CREATE_MODAL(state) {
    return Object.assign({}, state, { showCreator: true })
  },

  DEVICES_SET_VIEW(state, { payload }) {
    return Object.assign({}, state, { view: payload })
  },

  HIDE_DEVICE_CREATE_MODAL(state) {
    return Object.assign({}, state, { showCreator: false })
  },

  GET_DEVICES_PENDING(state) {
    return Object.assign({}, state, { loading: true })
  },

  GET_DEVICES_FULFILLED(state, { payload }) {
    const devices = payload
    const devices_by_id = {}
    devices.forEach(device => {
      devices_by_id[device.id] = device
    })

    return Object.assign({}, state, { devices, devices_by_id })
  },

  GET_DEVICE_PENDING(state) {
    return Object.assign({}, state, { loading: true })
  },

  GET_DEVICE_FULFILLED(state, { payload }) {
    const device = payload

    const next_devices = state.devices.map(d => {
      if (d.id === device.id)
        return device
      else
        return d
    })
    const next_devices_by_id = Object.assign({}, state.devices_by_id, { [device.id] : device })
    return Object.assign({}, state, {
      devices: next_devices,
      devices_by_id: next_devices_by_id,
      loading: false
    })
  },

  CREATE_DEVICE_FULFILLED(state, { payload }) {
    const nextDevices = state.devices.concat([payload])
    return Object.assign({}, state, { devices: nextDevices })
  },

  CREATE_DEVICE_PUBLIC_KEY_FULFILLED(state, { payload }) {
    const nextDevice = Object.assign({}, state.devices_by_id[payload.device_id])
    nextDevice.public_keys = nextDevice.public_keys.concat([payload])
    const nextDevicesByID = Object.assign({}, state.devices_by_id, { [payload.device_id]: nextDevice })
    return Object.assign({}, state, { devices_by_id: nextDevicesByID })
  },

  CREATE_DEVICE_PUBLIC_KEY_FAILED(state, action) {
    log("error creating device public key", action)
    return state
  },

  DELETE_DEVICE_PUBLIC_KEY_FULFILLED(state, { payload }) {
    const nextDevice = Object.assign({}, state.devices_by_id[payload.device_id])
    nextDevice.public_keys = nextDevice.public_keys.filter(other => {
      return other.id !== payload.id
    })
    const nextDevicesByID = Object.assign({}, state.devices_by_id, { [payload.device_id]: nextDevice })
    return Object.assign({}, state, { devices_by_id: nextDevicesByID })
  },

  CREATE_DEVICE_ACCESS_TOKEN_FULFILLED(state, { payload }) {
    const nextDevice = Object.assign({}, state.devices_by_id[payload.device_id])
    nextDevice.access_tokens = nextDevice.access_tokens.concat([payload])
    const nextDevicesByID = Object.assign({}, state.devices_by_id, { [payload.device_id]: nextDevice })
    return Object.assign({}, state, { devices_by_id: nextDevicesByID })
  },

  DELETE_DEVICE_ACCESS_TOKEN_FULFILLED(state, { payload }) {
    const nextDevice = Object.assign({}, state.devices_by_id[payload.device_id])
    nextDevice.access_tokens = nextDevice.access_tokens.filter(other => {
      return other.id !== payload.id
    })
    const nextDevicesByID = Object.assign({}, state.devices_by_id, { [payload.device_id]: nextDevice })
    return Object.assign({}, state, { devices_by_id: nextDevicesByID })
  },

  UPDATE_DEVICE_FULFILLED(state, { payload }) {
    const nextDevice = Object.assign({}, state.devices_by_id[payload.id], payload)
    const nextDevicesByID = Object.assign({}, state.devices_by_id, { [payload.id]: nextDevice })
    return Object.assign({}, state, { devices_by_id: nextDevicesByID })
  },

  DELETE_DEVICE_FULFILLED(state, { payload }) {
    const nextDevices = state.devices.filter(device => {
      return device.id !== payload.id
    })
    return Object.assign({}, state, { devices: nextDevices })
  },

}, initialValue)

const DeviceSelectors = {
  getDevice(state, id) {
    return state.devices.devices_by_id[id]
  },

  getView(state) {
    return state.devices.view
  }
}

export { DeviceSelectors }
